export class TargetRegistry {
    #manifests = new Map();
    #loaded = new Map();
    register(manifest) {
        if (this.#manifests.has(manifest.id)) {
            throw new Error(`Target "${manifest.id}" is already registered`);
        }
        this.#manifests.set(manifest.id, manifest);
    }
    list() {
        return [...this.#manifests.values()].map((m) => ({ id: m.id, displayName: m.displayName }));
    }
    has(id) {
        return this.#manifests.has(id);
    }
    /** Lazily loads (and caches) the target's implementation. Throws for an unregistered id. */
    async load(id) {
        const cached = this.#loaded.get(id);
        if (cached)
            return cached;
        const manifest = this.#manifests.get(id);
        if (!manifest)
            throw new Error(`Target "${id}" is not registered`);
        const target = await manifest.load();
        this.#loaded.set(id, target);
        return target;
    }
}
